import React from 'react';
import { motion } from 'motion/react';
import { Link } from 'react-router-dom';
import { Calculator, ArrowRight, BatteryMedium, Zap } from 'lucide-react';

const NaerasHybridFeatureCard: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="group relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-600 via-blue-600 to-indigo-800 p-6 shadow-xl shadow-indigo-900/20 w-full h-full flex flex-col justify-between"
    >
      {/* Background decoration */}
      <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-white/10 blur-3xl transition-transform duration-500 group-hover:scale-150" />
      <div className="absolute -bottom-12 -left-12 h-40 w-40 rounded-full bg-white/10 blur-3xl transition-transform duration-500 group-hover:scale-150" />

      <div className="relative z-10">
        <div className="mb-4 flex items-center justify-between">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/20 text-white backdrop-blur-md">
            <Calculator className="h-6 w-6" />
          </div>
          <div className="flex gap-2">
            <span className="flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md">
              <BatteryMedium className="h-3 w-3" />
              Hybrid
            </span>
            <span className="flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold text-white backdrop-blur-md">
              <Zap className="h-3 w-3" />
              NAERAS
            </span>
          </div>
        </div>

        <h3 className="mb-2 text-2xl font-bold text-white">
          NAERAS Hybrid Feature
        </h3>
        <p className="mb-6 text-sm text-indigo-100 line-clamp-2">
          Calculate and adjust hybrid bids, manage limits, and track offer performance.
        </p>
      </div>

      <div className="relative z-10 mt-auto">
        <Link
          to="/naeras/hybrid"
          className="flex w-full items-center justify-between rounded-xl bg-white px-5 py-3 text-sm font-bold text-indigo-700 shadow-lg transition-all hover:bg-indigo-50 hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0"
        >
          <span>Είσοδος στον Υπολογισμό</span>
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </motion.div>
  );
};

export default NaerasHybridFeatureCard;
